module.exports = __webpack_public_path__ + "img/IND-B-1-V.51f01368.png";